import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { OutageType } from './types';

export const outageTypesApi = createApi({
  reducerPath: 'outageTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/outage-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getOutageTypes: builder.query<OutageType[], void>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetOutageTypesQuery } = outageTypesApi;
